var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "apply-kcode" },
    [
      _c(
        "div",
        { staticClass: "yto-box" },
        [
          _c(
            "span",
            {
              staticClass: "systemColor title-box",
              on: { click: _vm.goBackPage },
            },
            [
              _c("svg-icon", {
                staticClass: "icon-back-box",
                attrs: { "icon-class": "icon_fanhui" },
              }),
              _vm._v("返回"),
            ],
            1
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.goApplyKcodePage } },
            [_vm._v("申请客户编码")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "yto-table yto-box" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tbodyList } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "customerCode",
                  label: "客户编码",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "customerName", label: "客户名称" },
              }),
              _c("el-table-column", {
                attrs: { label: "申请网点" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (scope.row.orgCode || "") +
                                "-" +
                                (scope.row.orgName || "")
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "审核状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.getApproveStatus(scope.row.status)
                            ),
                          },
                        }),
                        scope.row.status == 5
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "light",
                                  placement: "bottom-end",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "终止状态无法对“代收货款”的订单进行打印快递单操作，不允许拉取代收货款面单"
                                      ),
                                    ]),
                                  ]
                                ),
                                scope.row.status == 5
                                  ? _c("i", {
                                      staticClass:
                                        "el-icon-question systemColor",
                                      staticStyle: {
                                        "margin-left": "10px",
                                        cursor: "pointer",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "申请时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.createTime &&
                                scope.row.createTime.includes("T")
                                ? scope.row.createTime.split("T")[0]
                                : scope.row.createTime
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "原因" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.statusMsg
                          ? _c(
                              "span",
                              {
                                staticClass: "systemColor",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewReason(scope.row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "240" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.editKcodeInfo(scope.row, "view")
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        scope.row.status == -1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editKcodeInfo(scope.row, "edit")
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "原因",
            visible: _vm.reasonDialogVisible,
            "close-on-click-modal": false,
            width: "500px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.reasonDialogVisible = $event
            },
          },
        },
        [
          _c("div", [_vm._v(_vm._s(_vm.reasonInfo.statusMsg || ""))]),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer",
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }